import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';
import reportWebVitals from './reportWebVitals';



const routerBasename =
  process.env.NODE_ENV === 'production' ? process.env.PUBLIC_URL || '' : '';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Router basename={routerBasename}>
    <App />
  </Router>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
